import type { Breakpoint } from "@mui/material/styles";

/**
 * レスポンシブの基準（単一の正本）。
 * 直書きの "md" "sm" ではなく、ここの定数・useIsMobile を使う。
 *
 * - SP: MOBILE_BREAKPOINT 未満。新規画面は SP 対応がマスト。
 * - PC: MOBILE_BREAKPOINT 以上。タブレットは任意（PC レイアウトがそのまま出る）。
 */
export const MOBILE_BREAKPOINT: Breakpoint = "md";

/** ショーケース等で使う確認用ビューポート幅（px） */
export const VIEWPORT_PRESETS = {
  sp: { label: "SP", width: 390 },
  tablet: { label: "タブレット", width: 820 },
  pc: { label: "PC", width: 1280 },
} as const;

export type ViewportPreset = keyof typeof VIEWPORT_PRESETS;

/** SP でタップ領域として最低限確保する高さ（px） */
export const MIN_TAP_TARGET = 44;
